module.exports = __webpack_public_path__ + "img/88.5.COD.7941e3a1.png";